module.exports = __webpack_public_path__ + "static/media/truck_green_temp_yellow.57622926.png";